import { DollarSign, Users } from 'lucide-react';
import { SummarySectionCard } from './SummarySectionCard';
import { getDurationLabel } from '../../../utils/capacity-brackets.utils';

export function PricingSummary({ data }: { data: any }) {
  const brackets = data.capacityBrackets || [];
  const hasRequiredConfig = brackets.length > 0;

  return (
    <SummarySectionCard 
      title="5. Tranches de capacité & Tarifs" 
      icon={DollarSign}
      error={!hasRequiredConfig ? "Configuration requise pour publier" : null}
    >
      {brackets.length > 0 ? (
        <div className="space-y-4">
          {brackets.map((bracket: any, index: number) => (
            <div key={index} className="bg-white border border-gray-100 rounded-xl p-3 shadow-sm">
              <div className="flex items-center justify-between mb-3 border-b border-gray-50 pb-2">
                <span className="font-bold text-[#00303c] text-sm">{bracket.label}</span>
                <div className="flex items-center gap-1 text-[10px] font-bold text-gray-400 bg-gray-50 px-2 py-0.5 rounded-full">
                  <Users size={10} />
                  {bracket.minCapacity}-{bracket.maxCapacity}
                </div>
              </div>
              
              <div className="grid grid-cols-1 gap-y-1.5">
                {bracket.prices?.map((p: any, i: number) => (
                  <div key={i} className="flex items-center justify-between text-[11px]">
                    <span className="text-gray-500 font-medium">{getDurationLabel(p.durationType)}</span>
                    <span className="font-black text-[#00758d]">{p.price?.toLocaleString()} FCFA</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      ) : (
        <p className="text-sm text-[#8E0B56] font-medium italic">Aucune tranche configurée</p>
      )}
    </SummarySectionCard>
  );
}
